export default __webpack_public_path__ + "static/nar-bruker-vi-bilder-f2e68287346acba41c0eb39b6e4055a7.png";